import React, { useEffect, useState } from 'react'
import { Select } from '@blueprintjs/select';
import { Button, MenuItem } from '@blueprintjs/core';
import { useSelector } from 'react-redux';

import { IState } from '../../../../store/reducers';
import { IUser } from '../../../../models';
import { getUserName } from './utils';

type FilterUserInputProps = {
  operator: string;
  onChange: any;
  defaultFilledValue: any;
}

const FilterUserInput = ({ operator, onChange, defaultFilledValue }: FilterUserInputProps) => {
  const allUsers = useSelector((state: IState) => state.users.users);
  const [userListToShow, setUserListToShow] = useState(allUsers);
  const [selectedUser, setSelectedUser] = useState<IUser | null>(allUsers[0]);

  const handleSelectValue = (user: IUser) => {
    setSelectedUser(user);
    onChange(user.uid);
  }

  const handleSelect = (event: any, user: IUser) => {
    event.stopPropagation();
    document.getElementById('action_' + operator)?.click();
    handleSelectValue(user)
  };

  useEffect(() => {
    if (defaultFilledValue) {
      const user = allUsers.find(u => u.uid === defaultFilledValue)
      if (user) {
        handleSelectValue(user)
      }
    } else {
      handleSelectValue(allUsers[0])
    }
  }, [])

  const onSearchTextChange = (text: any) => {
    setUserListToShow(allUsers.filter((user: any) => user?.first_name.toLowerCase().includes(text.toLowerCase()) ||
      user?.last_name.toLowerCase().includes(text.toLowerCase())));
  };

  const generateSelectUserItem = (user: any, { modifiers, handleClick }: any) => {
    if (!modifiers.matchesPredicate) {
      return null;
    }
    return <MenuItem
      key={user.uid}
      text={getUserName(user)}
      aria-label={user.username}
      active={modifiers.active}
      onClick={(e: any) => handleSelect(e, user)}
    />;
  };

  return (
    <Select
      items={userListToShow}
      onQueryChange={onSearchTextChange}
      itemRenderer={generateSelectUserItem}
      onItemSelect={() => { }}
      noResults={<MenuItem disabled={true} text="No results." />}
      onActiveItemChange={setSelectedUser}
      activeItem={selectedUser}
      resetOnClose={true}
    >
      <Button id={'action_' + operator} className='select-btn'
        text={selectedUser?.first_name + ' ' + selectedUser?.last_name}
        rightIcon="double-caret-vertical" />
    </Select>
  )
}

export default FilterUserInput
